<div class="dialog-header">
  <div class="dialog-icon-wrapper">
    <div class="dialog-icon new">
      <i class="fa-solid fa-link"></i>
    </div>
    <div>
      <h2 class="dialog-title">Link Master Commercial</h2>
      <p class="dialog-subtitle">Select a master commercial to link</p>
    </div>
  </div>
  <button class="dialog-close" (click)="onCancel()">
    <i class="fa-solid fa-xmark"></i>
  </button>
</div>

<mat-dialog-content class="dialog-body">
  <div class="table-container">
    <div class="data-card">
      <div class="table-wrapper">
        <table mat-table [dataSource]="dataSource" matSort class="mat-mdc-table">

        <!-- Ref. Code Column -->
        <ng-container matColumnDef="refCode">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Ref. Code </th>
          <td mat-cell *matCellDef="let row">
            <span matRipple class="ref-code">{{row.referenceCode}}</span>
          </td>
        </ng-container>

        <!-- Brand Column -->
        <ng-container matColumnDef="brand">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Brand </th>
          <td mat-cell *matCellDef="let row">{{row.brand}}</td>
        </ng-container>

        <!-- Product Column -->
        <ng-container matColumnDef="product">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Product </th>
          <td mat-cell *matCellDef="let row">{{row.product}}</td>
        </ng-container>

        <!-- Ref. Title Column -->
        <ng-container matColumnDef="refTitle">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Ref. Title </th>
          <td mat-cell *matCellDef="let row">{{row.version}}</td>
        </ng-container>

        <!-- Filename Column -->
        <ng-container matColumnDef="filename">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Filename </th>
          <td mat-cell *matCellDef="let row">{{row.filename}}</td>
        </ng-container>

        <!-- Language Column -->
        <ng-container matColumnDef="language">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Language </th>
          <td mat-cell *matCellDef="let row">{{row.language | objectdesc}}</td>
        </ng-container>

        <!-- Type Column -->
        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Type </th>
          <td mat-cell *matCellDef="let row">{{row.type | objectdesc}}</td>
        </ng-container>

        <!-- Uploaded Column -->
        <ng-container matColumnDef="uploaded">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Uploaded </th>
          <td mat-cell *matCellDef="let row">{{row.dateCreated | date:'d/M/yyyy'}}</td>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef> Actions </th>
          <td mat-cell *matCellDef="let row">
            <div class="actions">
              <button matButton class="act-btn" (click)="onLinkSelectedCommercial(row)" matTooltip="Link this Commercial">
                <i class="fa-solid fa-link"></i>
              </button>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>

      <mat-paginator
        [pageSizeOptions]="[10, 25, 50, 100]"
        showFirstLastButtons>
      </mat-paginator>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="dialog-footer">
  <button class="btn-ghost" (click)="onCancel()">Cancel</button>
  <button class="btn-blue" (click)="onSearchCommercials()">Search Commercials</button>
</mat-dialog-actions>
